import { useState } from 'react';
import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import { Link } from 'react-router-dom';

import { userAppContext } from '../../../Context/Context';
import { UserContext } from '../../../types';

const registeredSsoProviders = { 'disgenet.com': 'entra-test', 'otsuka-us.com': 'otsuka' };

function Login() {
  const [errorMessage, setErrorMessage] = useState('');
  const { setIsAuthenticated, setAuthorization, setGroups } = userAppContext() as unknown as UserContext;
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    const emailValue = event.target.value.trim();
    setEmail(emailValue);
  };

  const handleSso = async (evt: React.FormEvent) => {
    evt.preventDefault();
    try {
      setIsLoading(true);
      setErrorMessage('');
      
      if (!email) {
        throw new Error('Please enter your email address');
      }
      
      const domain = email.split('@')[1];
      if (Object.keys(registeredSsoProviders)?.includes(domain)) {
        const ssoProvider = registeredSsoProviders[domain];
        await signInWithRedirect({
          provider: { custom: ssoProvider },
        });
      } else {
        throw new Error(`Domain "${domain}" is not registered for SSO. Please contact support@disgenet.com`);
      }
    } catch (err) {
      const typedError = err as { message: string };
      setErrorMessage(typedError.message || 'An error occurred during SSO login');
      
      // cleanup session
      setIsAuthenticated(false);
      setGroups([]);
      setAuthorization('');
      await signOut();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <link rel="canonical" href="/sso" />
      <div className="container txt-contenido">
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading" />
          </div>
        )}
        <div className="login-container mb-5">
          <div className="signin-container">
            <div className="col-12">
              <button type="button" className="close" aria-label="Close">
                <Link style={{ color: 'white' }} to="/" aria-hidden="true">
                  ×
                </Link>
              </button>
              <h3 className="login-title">SSO Login</h3>
              <form className="validate-form" onSubmit={handleSso}>
                <div className="wrap-input100 validate-input" data-validate="Email is required">
                  <label className="label-input100" style={{ color: 'white' }}>
                    Email:
                  </label>
                  <input
                    className="input100"
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChangeEmail}
                    required
                  />
                </div>
                <div className="container-contact100-form-btn">
                  <div className="wrap-contact100-form-btn">
                    <div className="contact100-form-bgbtn" />
                    <button className="contact100-form-btn">Send</button>
                  </div>
                </div>
                {errorMessage ? <p className="text-center">{errorMessage}</p> : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
